import React, { useState } from 'react'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { FormElementsSettings } from './form-elements-settings'
import { FormDesignSettings } from './form-design-settings'
import { FormActionSettings } from './form-action-settings'

export interface FormSettingsProps {
  entity: FormInterface
}

enum SubSettingsEnum {
  Fields = 'fields',
  Design = 'design',
  Action = 'action',
}

export const FormSettings = ({ entity }: FormSettingsProps) => {
  const [subSettings, setSubSettings] = useState<SubSettingsEnum>(
    SubSettingsEnum.Fields,
  )

  return (
    <>
      <Switcher
        btnList={[
          {
            value: SubSettingsEnum.Fields,
            content: 'components.core.toolbox.types.elements',
          },
          {
            value: SubSettingsEnum.Design,
            content: 'components.core.toolbox.types.design',
          },
          {
            value: SubSettingsEnum.Action,
            content: 'components.core.toolbox.types.action',
          },
        ]}
        value={subSettings}
        update={setSubSettings}
        wrapperClassName="p-0 mb-5"
      />

      {subSettings === SubSettingsEnum.Fields ? (
        <FormElementsSettings entity={entity} />
      ) : subSettings === SubSettingsEnum.Design ? (
        <FormDesignSettings entity={entity} />
      ) : (
        <FormActionSettings entity={entity} />
      )}
    </>
  )
}
